import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';

export function PrivacyPolicy() {
  const { i18n } = useTranslation();
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(`/locales/${i18n.language}/privacy.md`)
      .then(res => res.text())
      .then(text => setContent(text));
  }, [i18n.language]);

  return (
    <Wrapper>
      <ReactMarkdown>{content}</ReactMarkdown>
    </Wrapper>);
}

const Wrapper = styled.div`
  grid-column: 2 / -2;
  margin-top: 3em;
  margin-bottom: 5em;

  h1, h2 {
    color: var(--color-text);
    font-family: var(--heading-font), sans-serif;
    font-weight: 600;
    margin-top: 1rem;
  }
  h1 {
    font-size: clamp(1.5rem, -3rem + 9vw, 1rem);
    text-transform: uppercase;
  }
  h2 {
    font-size: 1.2rem;
  }
  a {
    color: var(--color-text);
    font-weight: 600;
  }
`;